function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1337",
  "data-name": "Path 1337",
  d: "M8.5,30.5h22V7.5l-7-7H8.5V15.6",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1338",
  "data-name": "Path 1338",
  d: "M23.5.5v7h7",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  id: "Line_252",
  "data-name": "Line 252",
  x2: 14,
  transform: "translate(12.5 12.5)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  id: "Line_253",
  "data-name": "Line 253",
  x2: 13,
  transform: "translate(13.5 17.5)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  id: "Line_254",
  "data-name": "Line 254",
  x2: 11,
  transform: "translate(15.5 22.5)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_511",
  "data-name": "Ellipse 511",
  cx: 7.5,
  cy: 7.5,
  r: 7.5,
  transform: "translate(0.5 15.5)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "Group_962",
  "data-name": "Group 962"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1339",
  "data-name": "Path 1339",
  d: "M10.3,19.9a3.446,3.446,0,0,0-2.6-1,2.609,2.609,0,0,0-2.4,2.3s-.9,3.5,1,5.1a2.935,2.935,0,0,0,3.1.3,2.992,2.992,0,0,0,.9-.7",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_255",
  "data-name": "Line 255",
  x2: 4.5,
  transform: "translate(3.5 22.2)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_256",
  "data-name": "Line 256",
  x2: 4.5,
  transform: "translate(3.5 24.3)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
}));

var SvgIconInvoice = function SvgIconInvoice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_963",
    "data-name": "Group 963",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconInvoice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_invoice.e59d6cc5.svg";
export { ForwardRef as ReactComponent };